(function($){
  var valorSlider = {
    init: function(){
      if ($('.valor-slider').length){
        valorSlider.initvalorSlider();
      }
    },
    initvalorSlider: function(){

      var $valorCount = $('.valor__count');
      $valorSlider = $('.valor-slider');
      $valorNav = $('.valor-slider-2');

      $valorSlider.flickity({
        prevNextButtons: false,
        autoPlay: false,
        wrapAround: true,
        pageDots: false,
        cellAlign: 'left',
      });

      $valorNav.flickity({
        asNavFor: '.valor-slider',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        fade: true,
      });

      var $flkty = $valorSlider.data('flickity');

      function updateStatus() {
        var $slideNumber = $flkty.selectedIndex + 1;
        $valorCount.html( $slideNumber + '/' + $flkty.slides.length);
      }

      updateStatus();
      $flkty.on( 'select', updateStatus );

      $('.valor__btns .btn-slider.m--prev').on('click', function(){
        $('.valor-slider').flickity('previous');
      });
      $('.valor__btns .btn-slider.m--next').on('click', function(){
        $('.valor-slider').flickity('next');
      });
    }
  };
  $(document).ready(valorSlider.init);
})(jQuery);
